module.exports = __webpack_public_path__ + "img/r2.55750df4.jpg";